// ── TRACKER FORM COMPONENTS (fp-nofodesk-9 follow-up) — extracted from TrackerPage ──
// Defined at module scope (outside DeadlineDashboard) so React preserves input
// focus across parent re-renders. FormCtx carries { formData, setFormData }.
import { useState, createContext, useContext } from "react";
import { FONT_H, useT } from "../theme";

// ── Stable form/search components (defined outside to preserve focus) ─
const _GARAMOND = FONT_H;

const FormCtx = createContext({});

function SearchInput({ val, setter, ph }) {
  const T = useT();
  return (
    <input value={val} onChange={(e) => setter(e.target.value)} placeholder={ph} style={{
      marginLeft: "auto", background: T.bgElevated, border: `1px solid ${T.border}`,
      borderRadius: 20, color: T.textBody, padding: "5px 16px", fontSize: 12,
      outline: "none", width: 240, fontFamily: _GARAMOND,
    }} />
  );
}

function FormField({ label, k, type = "text", opts, span }) {
  const T = useT();
  const { formData, setFormData } = useContext(FormCtx);
  const inputS = { width: "100%", background: T.inputBg, border: `1px solid ${T.border}`, borderRadius: 5, color: T.textBody, padding: "7px 10px", fontSize: 13, outline: "none", fontFamily: _GARAMOND, boxSizing: "border-box" };
  const labelS = { fontSize: 10, color: T.textFaint, fontFamily: _GARAMOND, letterSpacing: "0.06em", textTransform: "uppercase", marginBottom: 4, display: "block" };
  return (
    <div style={{ gridColumn: span ? "1 / -1" : undefined }}>
      <label style={labelS}>{label}</label>
      {type === "textarea" ? (
        <textarea value={formData[k] || ""} onChange={e => setFormData(d => ({ ...d, [k]: e.target.value }))} rows={3}
          style={{ ...inputS, resize: "vertical", lineHeight: 1.6 }} />
      ) : type === "select" ? (
        <select value={formData[k] || ""} onChange={e => setFormData(d => ({ ...d, [k]: e.target.value }))}
          style={{ ...inputS, cursor: "pointer" }}>
          <option value="">— select —</option>
          {(opts || []).map(o => <option key={o} value={o}>{o}</option>)}
        </select>
      ) : (
        <input type={type} value={formData[k] || ""} onChange={e => setFormData(d => ({ ...d, [k]: e.target.value }))}
          style={inputS} />
      )}
    </div>
  );
}

// Records actual NOA (Notice of Award) amounts year by year as they are received.
// Future years are left blank until the NOA arrives.
function NOASection() {
  const T = useT();
  const { formData, setFormData } = useContext(FormCtx);
  const [addYear, setAddYear] = useState(new Date().getFullYear());
  const [addAmt,  setAddAmt]  = useState("");

  const fyAmounts = formData.fyAmounts || {};
  const recorded  = Object.entries(fyAmounts)
    .filter(([, v]) => v)
    .sort(([a], [b]) => Number(a) - Number(b));

  const inp = { background:T.inputBg, border:`1px solid ${T.border}`, borderRadius:5, color:T.textBody, padding:"7px 10px", fontSize:13, outline:"none", fontFamily:_GARAMOND, boxSizing:"border-box" };

  const addEntry = () => {
    if (!addAmt.trim()) return;
    setFormData(d => ({ ...d, fyAmounts: { ...(d.fyAmounts || {}), [addYear]: addAmt.trim() } }));
    setAddAmt("");
  };
  const removeEntry = (yr) => {
    const next = { ...fyAmounts };
    delete next[yr];
    setFormData(d => ({ ...d, fyAmounts: next }));
  };

  return (
    <div style={{ gridColumn:"1 / -1" }}>
      <label style={{ fontSize:10, color:T.textFaint, fontFamily:_GARAMOND, letterSpacing:"0.06em", textTransform:"uppercase", marginBottom:8, display:"block" }}>
        NOA by Year — record actual award when received
      </label>
      {recorded.length > 0 && (
        <div style={{ marginBottom:10, display:"flex", flexDirection:"column", gap:4 }}>
          {recorded.map(([yr, amt]) => (
            <div key={yr} style={{ display:"flex", alignItems:"center", gap:10, background:T.bgElevated, borderRadius:5, padding:"6px 10px" }}>
              <span style={{ fontSize:12, color:T.textFaint, fontFamily:_GARAMOND, minWidth:40 }}>FY{yr}</span>
              <span style={{ fontSize:13, color:T.textBody, fontFamily:_GARAMOND, flex:1 }}>{amt}</span>
              <button onClick={() => removeEntry(yr)} style={{ background:"transparent", border:"none", color:T.textFaint, cursor:"pointer", fontSize:14, lineHeight:1, padding:"0 2px" }}>×</button>
            </div>
          ))}
        </div>
      )}
      <div style={{ display:"flex", gap:8, alignItems:"center" }}>
        <input type="number" min="2000" max="2100" value={addYear}
          onChange={e => setAddYear(Number(e.target.value))}
          style={{ ...inp, width:80 }} />
        <input type="text" placeholder="Amount e.g. $2,000,000" value={addAmt}
          onChange={e => setAddAmt(e.target.value)}
          onKeyDown={e => e.key === "Enter" && addEntry()}
          style={{ ...inp, flex:1 }} />
        <button onClick={addEntry}
          style={{ padding:"7px 14px", borderRadius:5, background:T.slateBlue, color:"#fff", border:"none", cursor:"pointer", fontSize:12, fontFamily:_GARAMOND, whiteSpace:"nowrap" }}>
          + Record
        </button>
      </div>
    </div>
  );
}


export { FormCtx, SearchInput, FormField, NOASection };
